import { c as _c } from "react/compiler-runtime";
import { WaveGroupType } from "./WaveGroup.types";
export default function WaveGroupTitle(t0) {
  const $ = _c(3);
  const {
    type
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      [WaveGroupType.VIEW]: "View",
      [WaveGroupType.DROP]: "Drop",
      [WaveGroupType.VOTE]: "Vote",
      [WaveGroupType.CHAT]: "Chat",
      [WaveGroupType.ADMIN]: "Admin"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const LABELS = t1;
  const t2 = LABELS[type];
  let t3;
  if ($[1] !== t2) {
    t3 = <div className="tw-flex tw-items-center"><span className="tw-font-normal tw-text-iron-500">{t2}</span></div>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
}